import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ArticleCard from '../components/ArticleCard';
import { Link, useLocation } from 'react-router-dom';
import '../styles/ArticlesListPage.css';

function ArticlesListPage() {
  const articlesData = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "JavaScript",
      title: "Modern JavaScript Techniques You Should Know in 2023",
      excerpt: "Discover the latest JavaScript features and patterns that are revolutionizing web development today.",
      link: "/articles/modern-javascript-techniques",
      featured: false
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "React",
      title: "Building Performant React Applications: A Deep Dive",
      excerpt: "Learn how to optimize your React apps for better performance and improved user experience.",
      link: "/articles/building-performant-react-applications",
      featured: false
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "Python",
      title: "Python for Data Science: Essential Libraries and Tools",
      excerpt: "Explore the most powerful Python libraries that every data scientist should master in their toolkit.",
      link: "/articles/python-for-data-science",
      featured: false
    },
    {
      id: 9,
      image: "https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "DevOps",
      title: "Deep Dive into Terraform: Beyond the Basics",
      excerpt: "Explore advanced Terraform techniques, best practices, and patterns for managing complex infrastructure at scale.",
      link: "/articles/deep-dive-into-terraform",
      featured: false
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "AI",
      title: "The Future of AI in Software Development",
      excerpt: "Exploring how artificial intelligence is transforming the way we build and maintain software applications.",
      link: "/articles/future-of-ai-in-software-development",
      featured: true
    },
    {
      id: 5,
      image: "https://images.unsplash.com/photo-1598520106830-8c45c2035460?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "Security",
      title: "Essential Cybersecurity Practices for Web Developers",
      excerpt: "Stay ahead of security threats with these proven strategies to protect your web applications.",
      link: "/articles/essential-cybersecurity-practices",
      featured: false
    },
    {
      id: 6,
      image: "https://images.unsplash.com/photo-1605745341112-85968b19335b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "DevOps",
      title: "The Benefits of Using Docker in 2025",
      excerpt: "Discover why Docker continues to be an essential tool for modern software development and deployment in 2025.",
      link: "/articles/benefits-of-using-docker-in-2025",
      featured: false
    },
    {
      id: 7,
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "DevOps",
      title: "Ansible Tips and Tricks for Advanced Automation",
      excerpt: "Practical techniques and patterns to level up your Ansible playbooks and make your infrastructure automation more efficient.",
      link: "/articles/ansible-tips-and-tricks",
      featured: false
    },
    {
      id: 8,
      image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "DevOps",
      title: "Kubernetes Basics: A Comprehensive Guide for Beginners",
      excerpt: "Learn the fundamental concepts of Kubernetes and how it can revolutionize your container orchestration strategy.",
      link: "/articles/kubernetes-basics",
      featured: false
    },
    {
      id: 11,
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "DevOps",
      title: "How to Use Python in DevOps: A Practical Guide",
      excerpt: "Learn how Python can streamline your DevOps workflow with practical examples and essential use cases.",
      date: "June 5, 2023",
      readTime: "7 min read",
      link: "/articles/how-to-use-python-in-devops",
      featured: false
    },
    {
      id: 12,
      image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "AI",
      title: "Will AI Take Over? Separating Fact from Fiction",
      excerpt: "A balanced examination of AI capabilities, limitations, and what the future might actually hold for human-AI coexistence.",
      date: "May 12, 2023",
      readTime: "10 min read",
      link: "/articles/will-ai-take-over",
      featured: false
    }
  ];

  const [filteredArticles, setFilteredArticles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const location = useLocation();

  // Parse query parameters for category and search
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const categoryParam = queryParams.get('category')?.toLowerCase() || 'all';
    const searchParam = queryParams.get('search') || '';
    
    setActiveCategory(categoryParam);
    setSearchTerm(searchParam);
    
    filterArticles(categoryParam, searchParam);
  }, [location.search]);

  // Function to filter articles based on category and search term
  const filterArticles = (category, search) => {
    let filtered = [...articlesData];
    
    // Filter by category if not 'all'
    if (category && category !== 'all') {
      filtered = filtered.filter(article => 
        article.category.toLowerCase() === category
      );
    }
    
    // Filter by search term if present
    if (search) {
      const searchLower = search.toLowerCase();
      filtered = filtered.filter(article => 
        article.title.toLowerCase().includes(searchLower) || 
        article.excerpt.toLowerCase().includes(searchLower)
      );
    }
    
    setFilteredArticles(filtered);
  };

  // Handle search input changes
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    filterArticles(activeCategory, e.target.value);
  };

  // Handle search form submission
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // Update URL with search term
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('search', searchTerm);
    window.history.pushState({}, '', `${location.pathname}?${searchParams.toString()}`);
  };

  return (
    <div className="articles-page">
      <Navbar />
      <div className="articles-hero">
        <h1>All Articles</h1>
        <p>Explore our collection of in-depth technical articles</p>
        
        <form className="search-form" onSubmit={handleSearchSubmit}>
          <input
            type="text"
            placeholder="Search articles..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <button type="submit">
            <i className="fas fa-search"></i>
          </button>
        </form>
      </div>
      <main>
        <div className="articles-container">
          <div className="article-filters">
            <h3>Categories</h3>    
            <ul className="category-list">
              <li>
                <Link 
                  to="/articles" 
                  className={activeCategory === 'all' ? 'active' : ''}
                >
                  All
                </Link>
              </li>
              <li>
                <Link 
                  to="/articles?category=javascript" 
                  className={activeCategory === 'javascript' ? 'active' : ''}
                >
                  JavaScript
                </Link>
              </li>
              <li>
                <Link 
                  to="/articles?category=react" 
                  className={activeCategory === 'react' ? 'active' : ''}
                >
                  React
                </Link>
              </li>
              <li>
                <Link 
                  to="/articles?category=python" 
                  className={activeCategory === 'python' ? 'active' : ''}
                >
                  Python
                </Link>
              </li>
              <li>
                <Link 
                  to="/articles?category=ai" 
                  className={activeCategory === 'ai' ? 'active' : ''}
                >
                  AI
                </Link>
              </li>
              <li>
                <Link 
                  to="/articles?category=security" 
                  className={activeCategory === 'security' ? 'active' : ''}
                >
                  Security
                </Link>
              </li>
              <li>
                <Link 
                  to="/articles?category=devops" 
                  className={activeCategory === 'devops' ? 'active' : ''}
                >
                  DevOps
                </Link>
              </li>
            </ul>
          </div>
          <div className="articles-list">
            {filteredArticles.length > 0 ? (
              filteredArticles.map(article => (
                <ArticleCard key={article.id} article={article} />
              ))
            ) : (
              <div className="no-results">
                <p>No articles found. Try adjusting your search or category filter.</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ArticlesListPage;
